import api from '../../../../api/api';

export const trackDrafts = (tracks) =>
  Object.fromEntries(tracks.filter((t) => t.id != null).map((t) => [t.id, t.userRating ?? null]));
export function changedTrackRatings(baseline, drafts) {
  return Object.entries(drafts)
    .filter(([id, rating]) => baseline[id] !== rating)
    .map(([id, rating]) => {
      if (
        !(Number(id) > 0) ||
        (rating !== null &&
          (!Number.isFinite(rating) || rating < 0 || rating > 5 || (rating * 2) % 1))
      )
        throw new Error('Invalid track rating');
      return { trackId: Number(id), rating };
    });
}
const body = (response) => response.data?.data ?? response.data;
export async function prepareTrackRatings(album, target, assertCurrent) {
  assertCurrent();
  let resolved = album;
  if (target.id == null) {
    if (!album.albumSource || !album.sourceId) throw new Error('Missing album identity');
    const query = new URLSearchParams({
      type: album.albumSource.toLowerCase(),
      id: album.sourceId,
    });
    resolved = body(await api.postAuth(`/albums/resolve-for-track-rating?${query}`));
    assertCurrent();
  }
  const tracks = resolved.tracks ?? [];
  const selected = tracks.find(
    (t) =>
      t.id != null &&
      (target.id != null
        ? t.id === target.id
        : (target.sourceId != null && t.sourceId === target.sourceId) ||
          ((t.discNumber ?? 1) === (target.discNumber ?? 1) &&
            t.trackNumber === target.trackNumber)),
  );
  if (!selected) throw new Error('Track missing');
  // Never seed private drafts from the legacy, account-unscoped album cache.
  const summaries = await Promise.all(
    tracks
      .filter((t) => t.id != null)
      .map(async (t) => {
        assertCurrent();
        const summary = body(await api.getAuth(`/tracks/${t.id}/rating`));
        assertCurrent();
        return { ...t, ...summary, userRating: summary.userRating ?? null, id: t.id };
      }),
  );
  assertCurrent();
  return {
    album: { ...resolved, tracks: summaries, ratingTrackCount: tracks.length },
    targetId: selected.id,
  };
}
export async function persistTrackRatings(updates, assertCurrent) {
  assertCurrent();
  // A rejected write must not allow a still-running write to race with retry/refetch.
  const results = await Promise.allSettled(
    updates.map(async (update) => {
      assertCurrent();
      const response =
        update.rating === null
          ? await api.deleteAuth(`/tracks/${update.trackId}/rating`)
          : await api.putAuth(`/tracks/${update.trackId}/rating`, { rating: update.rating });
      return { ...update, summary: body(response) };
    }),
  );
  assertCurrent();
  return {
    successes: results.filter((r) => r.status === 'fulfilled').map((r) => r.value),
    failure: results.find((r) => r.status === 'rejected')?.reason,
  };
}
export function trackSummary(tracks, totalTracks, en) {
  const total = totalTracks || tracks.length;
  if (tracks.length < total)
    return en
      ? `Track information available for ${tracks.length} of ${total} tracks`
      : `전체 ${total}곡 중 ${tracks.length}곡 정보 제공`;
  const minutes = Math.round(
    tracks.reduce((sum, t) => sum + (Number(t.durationMs) || 0), 0) / 60000,
  );
  const hours = Math.floor(minutes / 60);
  const runtime = en
    ? `${hours ? `${hours} hr ` : ''}${minutes % 60} min`
    : `${hours ? `${hours}시간 ` : ''}${minutes % 60}분`;
  return en ? `${total} tracks · ${runtime} total` : `${total}곡 · 총 ${runtime}`;
}

export async function loadMyTrackRatings(assertCurrent) {
  assertCurrent();
  const ratings = body(await api.getAuth('/me/track-ratings'));
  assertCurrent();
  return Array.isArray(ratings) ? ratings : [];
}
